import { Component, Input } from '@angular/core';
import {
  ProductToast,
  ProductToastTypes,
} from '../../models/product-toast.model';
import { ProductDetailToastService } from '../../services/product-detail-toast.service';

@Component({
  selector: 'app-product-detail-toast',
  templateUrl: './product-detail-toast.component.html',
  styleUrls: ['./product-detail-toast.component.scss'],
})
export class ProductDetailToastComponent {
  @Input() toast: ProductToast;
  types = ProductToastTypes;

  constructor(private productDetailToastService: ProductDetailToastService) {}

  dismiss() {
    this.productDetailToastService.clearToast();
  }
}
